module.exports = __webpack_public_path__ + "static/img/img6.ab5f19b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/pic/img6.png
// module id = CR8s
// module chunks = 0